import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/success.png'
import _imports_1 from '../assets/kf2.png'


const _withScopeId = n => (_pushScopeId("data-v-05a43806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nonbid_success" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ok" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "订单已确认！"),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 您的保函申请已提交出函机构审批，您可以关注蔓延公众号， "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("我们将为您实时推送最新进度信息。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "kf" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "btn" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "/details" }, "查看订单")
  ])
], -1))
const _hoisted_3 = { class: "model" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "出函进度", -1))
const _hoisted_5 = { class: "steps" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "保函申请"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "保函申请提交成功"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/16 14:15:11")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "make" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "a" }, "订单确认"),
  /*#__PURE__*/_createElementVNode("div", { class: "b" }, "保函订单已确认"),
  /*#__PURE__*/_createElementVNode("div", { class: "t" }, "2022/11/16 14:20:05")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "风控审批", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "保费支付", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "签署协议", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step" }, "成功出函", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_steps, {
          direction: "vertical",
          active: 1
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_van_step, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}